import { Alert } from "@mui/material";
import React from "react";
import styled from "styled-components/macro";

const StyledBanner = styled(Alert)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
  margin: 0;
  border-radius: 0;
  background-color: #d32f2f;
  color: white;
  padding: ${(props) => props.theme.spacing(1.5)} ${(props) => props.theme.spacing(2)};
  
  & .MuiAlert-icon {
    color: white;
  }
  
  & .MuiAlert-message {
    color: white;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  a {
    color: white;
    text-decoration: underline;
    font-weight: bold;
    
    &:hover {
      text-decoration: none;
    }
  }
`;

function DeprecationBanner() {
  return (
    <StyledBanner severity="error">
      <strong>Deprecated:</strong>&nbsp; This website is deprecated and kept for archive purpose only. For latest version, please visit{" "}
      <a href="https://openscaler.net" target="_blank" rel="noopener noreferrer">
        https://openscaler.net
      </a>
    </StyledBanner>
  );
}

export default DeprecationBanner;

